import React from "react";
import TemplatePart from "./TemplatePart";
import ITemplatePart from "../../../../interfaces/DynamicCampaigns/ITemplatePart";

const DescriptionPart: React.FC<ITemplatePart> = (props) => {
    return <TemplatePart {...props} size="w-2/3" />;
};

export default DescriptionPart;
